import Splide from "@splidejs/splide";

export default class AutoSplide extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.splide = new Splide(this);

        this.splide.on('move', (newIndex) => {
            const slides = this.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
            const bg = slides[newIndex]?.dataset.bg;
            if (bg) this.style.setProperty('--slide-bg', bg);
        });

        this.splide.mount();
    }

}